import styled from 'styled-components';
import Button from './component';

export default styled(Button)`
  background-color: white;
  position: fixed;
  bottom: 0;
  padding: 16px;
  width: 336px;
  height: 64px;
  .feedback {
    font-weight: 500;
    text-align: center;
    display: block;
    margin: 8px;

    &__error {
      color: var(--redCherry);
    }

    &__success {
      color: var(--success700);
    }
  }
  button {
    background: var(--accent-color-blue);
    color: var(--primary-background);
    border: 1px solid var(--accent-color-blue);
  }
`;
